"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var platform_browser_1 = require("@angular/platform-browser");
var card_iframe_service_1 = require("./card-iframe.service");
var view_models_1 = require("./../view-models");
var PaymentIFrameComponent = (function () {
    function PaymentIFrameComponent(sanitizer, cardIFrameService) {
        this.sanitizer = sanitizer;
        this.cardIFrameService = cardIFrameService;
        this.onPaymentResponse = new core_1.EventEmitter();
        this.errors = null;
        this.iframeSrc = 'about:blank';
    }
    PaymentIFrameComponent.prototype.ngOnInit = function () {
        this.initialize();
        // only setup response listener once, if done more than once, it will trigger more than once on form submit
        this.setupResponseListener();
    };
    PaymentIFrameComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('message', this.iframeListener, false);
    };
    PaymentIFrameComponent.prototype.reloadForm = function () {
        if (this.showBillingInfo()) {
            this.paymentFormData.billing.paymentToken = null;
        }
        this.reloadIFrame();
    };
    PaymentIFrameComponent.prototype.reloadIFrame = function () {
        this.errors = null;
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
        this.initialize();
    };
    PaymentIFrameComponent.prototype.initialize = function () {
        this.fillDisplayData(this.paymentFormData.billing);
        // sets the payment URL for the iframe
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.cardIFrameService.buildCardIFrameURL(this.paymentFormData));
    };
    PaymentIFrameComponent.prototype.showErrors = function () {
        return this.errors !== null && this.errors !== undefined;
    };
    PaymentIFrameComponent.prototype.showBillingInfo = function () {
        return Boolean(this.paymentFormData.billing
            && this.paymentFormData.billing.paymentToken !== null
            && this.paymentFormData.billing.paymentToken !== undefined);
    };
    PaymentIFrameComponent.prototype.showPaymentIframe = function () {
        return (this.showErrors() === false && this.showBillingInfo() === false);
    };
    PaymentIFrameComponent.prototype.submitPayment = function (billing) {
        if (billing === void 0) { billing = null; }
        if (this.onPaymentResponse) {
            if (billing) {
                this.paymentFormData.billing = billing;
            }
            this.onPaymentResponse.emit(this.paymentFormData);
        }
    };
    PaymentIFrameComponent.prototype.windowListener = function (event) {
        if (event.data) {
            var key = event.message ? 'message' : 'data';
            var data = event[key];
            if (data) {
                if (data.customerId === 'ERROR') {
                    this.handlePaymentError();
                }
                else if (data.card) {
                    var billing = new view_models_1.BillingFormInfo();
                    billing.email = data.email;
                    billing.paymentToken = data.cardToken;
                    billing.address1 = data.card.addressLine1;
                    billing.address2 = null;
                    billing.city = data.card.addressCity;
                    billing.stateOrProvince = data.card.addressState;
                    billing.postalCode = data.card.addressZip;
                    billing.country = data.card.addressCountry;
                    billing.name = data.card.name;
                    billing.expMonth = data.card.expMonth;
                    billing.expYear = data.card.expYear;
                    billing.last4 = data.card.last4;
                    billing.cardType = data.card.type;
                    billing.customerId = data.customerId ? data.customerId : data.recipientId;
                    if (this.paymentFormData.forDisbursements) {
                        billing.recipientId = data.recipientId;
                        billing.recipientCardId = data.card.id;
                        billing.type = 'Debit Card';
                    }
                    this.fillDisplayData(billing);
                    // calls back to parent controller to continue
                    this.submitPayment(billing);
                }
            }
        }
    };
    PaymentIFrameComponent.prototype.handlePaymentError = function () {
        this.errors = [];
        if (this.paymentFormData.errorMessage) {
            this.errors.push(this.paymentFormData.errorMessage);
        }
        else if (this.paymentFormData.forDisbursements) {
            this.errors.push("Sorry, we can't disburse to that card, please try another");
        }
        else {
            this.errors.push("We're sorry, but we've encountered a problem while submitting billing information for this trip. Please try again.");
        }
    };
    PaymentIFrameComponent.prototype.setupResponseListener = function () {
        var _this = this;
        this.iframeListener = function (e) {
            if (_this.paymentFormData.baseUrl.indexOf(e.origin) > -1) {
                _this.windowListener(e);
            }
        };
        window.addEventListener('message', this.iframeListener, false);
    };
    PaymentIFrameComponent.prototype.fillDisplayData = function (billing) {
        if (billing) {
            this.cardType = billing.cardType;
            this.lastFour = billing.last4;
            this.expiration = billing.expMonth + '/' + billing.expYear;
        }
    };
    return PaymentIFrameComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.PaymentFormData)
], PaymentIFrameComponent.prototype, "paymentFormData", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PaymentIFrameComponent.prototype, "onPaymentResponse", void 0);
PaymentIFrameComponent = __decorate([
    core_1.Component({
        selector: 'payment-iframe',
        template: "<div *ngIf=\"showErrors()\">     <div class=\"bs-callout bs-callout-danger\">         <ul>             <li *ngFor=\"let errorMessage of errors\">                 {{errorMessage}}             </li>         </ul>     </div>     <button class=\"btn btn-lg btn-cust\" (click)=\"reloadIFrame()\">Re-enter card information</button> </div> <div *ngIf=\"showBillingInfo()\" class=\"paymentContainer\">     <div class=\"cardIconContainer\"><i class=\"fa fa-lg fa-credit-card\"></i></div>     <div class=\"paymentRow\">         <h3>Card type</h3>         {{cardType}}     </div>     <div class=\"paymentRow\">         <h3>Last 4 of card</h3>         {{lastFour}}     </div>     <div class=\"paymentRow paymentRowMargin\">         <h3>Expiring</h3>         {{expiration}}     </div>     <div class=\"paymentRow\">         <button class=\"btn btn-cust\" (click)=\"reloadForm()\">Enter a new card</button>         <button class=\"btn btn-cust\" (click)=\"submitPayment()\">Keep this card</button>     </div> </div> <iframe [src]=\"iframeSrc\"          class=\"payment-iframe col-xs-12\"          *ngIf=\"showPaymentIframe()\"         [class.master-pass]=\"paymentFormData?.enableMasterPass\"></iframe>",
        styles: ["\n        iframe {\n            border: none;\n            height: 580px;\n            overflow: hidden;\n            padding: 0px;\n        }\n\n        iframe.master-pass {\n            height: 720px;\n        }\n    "]
    }),
    __metadata("design:paramtypes", [platform_browser_1.DomSanitizer, card_iframe_service_1.CardIFrameService])
], PaymentIFrameComponent);
exports.PaymentIFrameComponent = PaymentIFrameComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/payments/payment-iframe.component.js